<template>
  <div class="Checkout__Footer">
    <el-row class="Checkout__Footer--Inner">
      <div class="Checkout__Footer__section">
        <div class="Checkout__Footer__Label">
          Certificados de segurança:
        </div>
        <div class="Checkout__Footer__Logo">
          <img :alt="AppConfig.name" src='@/assets/icons/security/shopify.png' />
        </div>
        <div class="Checkout__Footer__Logo">
          <img :alt="AppConfig.name" src='@/assets/icons/security/geotrust.png' />
        </div>
        <div class="Checkout__Footer__Logo">
          <img :alt="AppConfig.name" src='@/assets/icons/security/pci.png' />
        </div>
      </div>
      <div class="Checkout__Footer__section">
        <div class="Checkout__Footer__Label">
          Meios de pagamento:
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('credit_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Visa.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('credit_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Master.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('credit_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/ELO.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('credit_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Hiper.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('credit_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Diners.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('credit_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Hipercard.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('credit_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/AMEX.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('pix')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/PIX.png' />
        </div>
        <!-- <div class="Checkout__Footer__Logo">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Itaú.png' />
        </div> -->
        <!-- <div class="Checkout__Footer__Logo">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Bradesco.png' />
        </div> -->
        <!-- <div class="Checkout__Footer__Logo">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Banco do Brasil.png' />
        </div> -->
        <!-- <div class="Checkout__Footer__Logo">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Banrisul.png' />
        </div> -->
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('bankslip')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/Boleto.png' />
        </div>
        <div class="Checkout__Footer__Logo" v-if="AppConfig.payment_informations.payment_methods.includes('personal_card')">
          <img :alt="AppConfig.name" src='@/assets/icons/paymentOptions/personal_card.png' />
        </div>

      </div>
    </el-row>
    <el-row class="Checkout__Footer--Inner">
      <div class="Checkout__Footer__section">
        <el-link type="primary" @click="privacyModal = true" class="Checkout__Footer__Label" v-if="CheckoutConfig && CheckoutConfig.generalConfig.privacy_policy">
          Política de privacidade
        </el-link>
      </div>
    </el-row>

    <el-dialog
      title="Política de privacidade"
      :visible.sync="privacyModal"
      v-if="CheckoutConfig && CheckoutConfig.generalConfig.privacy_policy"
      >
      <span>
        {{CheckoutConfig.generalConfig.privacy_policy}}
      </span>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="privacyModal = false">Li e aceito as politicas de privacidade</el-button>
      </span>
    </el-dialog>

    <el-row class="Checkout__Footer--Inner Checkout__Footer--PoweredBy">
      <a href="https://budadigital.com.br" target="_blank" rel="noopener noreferrer" class="Checkout__Footer__PoweredBy__Link">
        Powered by <strong>Buda Digital</strong>
      </a>
    </el-row>
  </div>
</template>

<script>
// @ is an alias to /src
// import { mapGetters, mapActions } from 'vuex'
import { mapGetters } from 'vuex'
export default {
  name: 'CheckoutFooter',
  components: {

  },
  data () {
    return {
      privacyModal: false
    }
  },
  computed: {
    ...mapGetters(['AppConfig', 'Checkout', 'CheckoutConfig'])
  },
  created () {
  },
  methods: {
  }
}
</script>

<style scoped>
.Checkout__Footer--PoweredBy {
  justify-content: center;
  padding: 8px 0 4px;
  margin-top: 4px;
  border-top: 1px solid #eaeaea;
}

.Checkout__Footer__PoweredBy__Link {
  font-size: 11px;
  color: #999;
  text-decoration: none;
  transition: color 0.2s;
}

.Checkout__Footer__PoweredBy__Link:hover {
  color: #555;
}

.Checkout__Footer__PoweredBy__Link strong {
  font-weight: 600;
}
</style>
